import React, { useState, useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import EventLog from "./EventLog/";
import Exceptions from "./EventLog/exceptions";
import CustomNotifications from "./EventLog/CustomNotifications";
import styles from "./styles";
import { useSelector } from "react-redux";
import { TabsGenerator } from "../../../../Common";
import AlertSettings from "./EventLog/AlertSettings";
import PushNotificationSettings from "./EventLog/PushNotificationSettings";
import SolutionGuide from "./EventLog/SolutionGuide";


const tabsList = [
  {
    label: "Alerts",
    value: "stock_alerts",
    component:<EventLog/>
  },

  // {
  //   label: "Exceptions",
  //   value: "exceptions",
  //   component:<Exceptions/>
  // },
  {
    label: "Custom Notifications",
    value: "custom_notifications",
    component:<CustomNotifications/>
  },
  {
    label: "Email Settings",
    value: "settings",
    component:<AlertSettings/>
  },
  {
    label: "Push Notifications",
    value: "push_notifications",
    component:<PushNotificationSettings/>
  },
  {
    label: "Solution Guide",
    value: "solution_guide",
    component:<SolutionGuide/>
  },
];

const EventLogs = () => {
  const current_user = useSelector((state) => state.userReducer.current_user);
  const classes = styles();
  const [activeTab, setActiveTab] = useState("stock_alerts");
  const [tabs, setTabs] = useState([]);

  const handleTabChange = (_, newValue) => {
    setActiveTab(newValue);
  };

  // Only Super Admins and internal DMV staff may manage solution guides.
  // Note: @dmvi.com is NOT internal - those addresses belong to customer
  // accounts - so the check is on @digitalmediavending.com. The backend
  // enforces the same rule (settings.SOLUTION_GUIDE_EMAIL_DOMAINS).
  const canManageSolutionGuide =
    current_user.type === "SA" ||
    (current_user.email || "").trim().toLowerCase().endsWith("@digitalmediavending.com");

  const withSolutionGuide = (values) =>
    canManageSolutionGuide ? [...values, "solution_guide"] : values;

  useEffect(() => {
    if (current_user.type === "SU") {
      setTabs(
        tabsList.filter(
          (x) => withSolutionGuide(["stock_alerts", "exceptions", "settings"]).indexOf(x.value) > -1
        )
      );
    }

   else if (
      current_user.type === "OP" ||
      current_user.type === "DU" ||
      current_user.type === "SA" ||
      current_user.type === "DE"
    ) {
      setTabs(
        tabsList.filter(
          (x) => withSolutionGuide(["stock_alerts", "exceptions", "custom_notifications", "settings", "push_notifications"]).indexOf(x.value) > -1
        )
      );
    }

   else if (current_user.type === "FO") {
      setTabs(
        tabsList.filter(
          (x) => withSolutionGuide(["stock_alerts", "custom_notifications", "settings", "push_notifications"]).indexOf(x.value) > -1
        )
      );
    }

    else {
      setTabs(
        tabsList.filter(
          (x) => withSolutionGuide(["stock_alerts", "custom_notifications", "settings", "push_notifications"]).indexOf(x.value) > -1
        )
      );
    }
  }, [current_user.type, current_user.email]);

  return (
    

    <>
      <TabsGenerator
        tabsList={tabs}
        activeTabs={activeTab}
      />
    </>
  );
};

export default EventLogs;
